import script from "./Deliver.vue?vue&type=script&setup=true&lang=js"
export * from "./Deliver.vue?vue&type=script&setup=true&lang=js"

import "./Deliver.vue?vue&type=style&index=0&id=006b7464&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-006b7464"]])

export default __exports__